import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITravelPurpose, ITravelPurposeState } from "./travelpurposeModel";
import {
  createTravelPurpose,
  deleteTravelPurpose,
  getAllActiveTravelPurposes,
  getAllTravelPurpose,
  getTravelPurposeByID,
  travelPurposeActiveInactive,
  updateTravelPurpose,
} from "./services/travelpurpose.services";

const initialState: ITravelPurposeState = {
  loading: false,
  formLoading: false,
  error: "",
  TravelPurposeList: [],
  TravelPurposeID: null,
  TravelPurposeDetail: {
    TravelPurpose: "",
    IsActive: 1,
  },
};

const travelpurposeSlice = createSlice({
  name: "travelpurpose",
  initialState,
  reducers: {
    clearTravelPurposeDetails: (state) => {
      state.TravelPurposeDetail = initialState.TravelPurposeDetail;
    },
    setTravelPurposeID: (state, action) => {
      state.TravelPurposeID = action.payload;
    },
    clearTravelPurposeID: (state) => {
      state.TravelPurposeID = initialState.TravelPurposeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTravelPurpose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTravelPurpose.fulfilled,
      (state, action: PayloadAction<ITravelPurpose[]>) => {
        state.loading = false;
        state.TravelPurposeList = action.payload || [];
      }
    );
    builder.addCase(getAllTravelPurpose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TravelPurposeList = [];
    });
    builder.addCase(getAllActiveTravelPurposes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTravelPurposes.fulfilled,
      (state, action: PayloadAction<ITravelPurpose[]>) => {
        state.loading = false;
        state.TravelPurposeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTravelPurposes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TravelPurposeList = [];
    });
    builder.addCase(createTravelPurpose.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createTravelPurpose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTravelPurpose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTravelPurpose.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateTravelPurpose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTravelPurpose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTravelPurpose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTravelPurpose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTravelPurpose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(travelPurposeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(travelPurposeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(travelPurposeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTravelPurposeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTravelPurposeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TravelPurposeDetail = action.payload;
    });
    builder.addCase(getTravelPurposeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TravelPurposeDetail = initialState.TravelPurposeDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearTravelPurposeDetails,
  setTravelPurposeID,
  clearTravelPurposeID,
} = travelpurposeSlice.actions;
export default travelpurposeSlice.reducer;
